export class SearchContentComponent {
    readonly controlActive = 'active';
    private contentTextItems: HTMLElement[];
    private searchInputItems: HTMLElement[];
    private contentIdItems: HTMLElement[];
    private searchBtnItems: HTMLElement[];
    private contentTextSimpleItems: HTMLElement[];
    private contentTextMobileItems: HTMLElement[];
    private contentTextMobileSimpleItems: HTMLElement[];
    private controlMenuIdItems: HTMLElement[];

    constructor(
        private container: HTMLElement
    ) {
        this.contentTextItems
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-content-text]'));
        this.searchInputItems = Array.prototype.slice.call(this.container.querySelectorAll('[data-search]'));
        this.contentIdItems = Array.prototype.slice.call(this.container.querySelectorAll('[data-content-id]'));
        this.searchBtnItems = Array.prototype.slice.call(this.container.querySelectorAll('[data-search-btn]'));
        this.contentTextSimpleItems = [];
        this.contentTextMobileItems
            = Array.prototype.slice.call(this.container.querySelectorAll('[data-content-text-item-mobile]'));
        this.contentTextMobileSimpleItems = [];
        this.controlMenuIdItems =
            Array.prototype.slice.call(this.container.querySelectorAll('[data-control-menu-id]'));
    }
    public initialize(): void {
        let textSearch = ''
        this.contentTextItems.forEach((contentTextItem, index) => {
            this.contentTextSimpleItems.push(contentTextItem);
            this.contentTextMobileSimpleItems.push(this.contentTextMobileItems[index]);
        });

        this.searchInputItems.forEach((searchInputItem: HTMLElement, index: number): void => {

            searchInputItem.addEventListener('input', () => {
                const currentSearchInputItem: HTMLInputElement | null = searchInputItem as HTMLInputElement
                if (currentSearchInputItem) {
                    textSearch = currentSearchInputItem.value;
                }
            });

            this.searchBtnItems[index].addEventListener('submit', (e) => {
                e.preventDefault();
                const windowOuterWidth: number = window.outerWidth;
                if (windowOuterWidth > 680) {
                    this.showSearchResults(
                        windowOuterWidth,
                        this.contentTextSimpleItems,
                        this.contentIdItems,
                        this.controlActive,
                        textSearch,
                        null
                    );
                } else {
                    this.showSearchResults(
                        windowOuterWidth,
                        this.contentTextMobileSimpleItems,
                        this.contentIdItems,
                        this.controlActive,
                        textSearch,
                        this.controlMenuIdItems
                    );
                }
            });
        });
    }
    showSearchResults(
        windowOuterWidth: number,
        contentTextSimpleItems: HTMLElement[],
        contentIdItems: HTMLElement[],
        controlActive: string,
        textSearch: string,
        controlMenuIdItems: HTMLElement[] | null
    ) {

        const filteredContentTextSimpleItems: HTMLElement[] = contentTextSimpleItems.filter(
            (contentTextSimpleItem: HTMLElement): boolean => {
                const h5: HTMLHeadingElement | null = contentTextSimpleItem.querySelector('h5');
                const text: string | undefined = h5?.innerText.toLowerCase()
                const textSearchToLowerCase: string | undefined = textSearch.toLowerCase();

                return typeof textSearchToLowerCase !== 'undefined' && text
                    ? text.indexOf(textSearchToLowerCase) >= 0
                    : false
            }
        );
        contentIdItems.forEach(contentIdItem => {
            contentIdItem?.classList.remove(controlActive);
        });
        contentTextSimpleItems.forEach(contentTextSimpleItem => {
            contentTextSimpleItem?.classList.remove(controlActive);
            if (windowOuterWidth <= 680) {
                const contentTextMobile: HTMLElement | null
                    = contentTextSimpleItem.closest('[data-content-text-mobile]')
                if (contentTextMobile) {
                    contentTextMobile.style.height = '0';
                }
                const controlMenu: HTMLElement | null = contentTextSimpleItem.closest('[data-control-menu]');
                controlMenu?.classList.remove(controlActive);
            }
        });
        if (controlMenuIdItems) {
            controlMenuIdItems.forEach((controlMenuIdItem: HTMLElement) => {
                const ul: HTMLUListElement | null = controlMenuIdItem.querySelector('ul');
                if (controlMenuIdItem && controlMenuIdItem.dataset.controlMenu === 'parent' && ul) {
                    ul.style.height = '0';
                }
            });
        }
        if (filteredContentTextSimpleItems && filteredContentTextSimpleItems.length > 0) {
            filteredContentTextSimpleItems[0].scrollIntoView();
        }

        filteredContentTextSimpleItems.forEach(filteredContentTextSimpleItem => {
            filteredContentTextSimpleItem.style.height = 'auto';
            filteredContentTextSimpleItem?.classList.add(controlActive);
            if (
                filteredContentTextSimpleItem.closest('ul')
                && filteredContentTextSimpleItem.closest('[data-content-text-mobile]')
            ) {
                const controlMenu: HTMLElement | null = filteredContentTextSimpleItem.closest('[data-control-menu]');
                controlMenu?.classList.add(controlActive);
                if (controlMenu) {
                    this.recursivelyIterateThroughMenuItems(controlMenu);
                }
            }
            filteredContentTextSimpleItem.closest('[data-content-id]')
                ?.classList.add(controlActive);
        });

    }
    recursivelyIterateThroughMenuItems(controlMenu: HTMLElement) {
        const controlActive = 'active';
        const currentUl = controlMenu.closest('ul');

        if (currentUl) {
            currentUl.style.height = 'auto';
            //if (currentUl.closest('[data-control-menu]')) {
                controlMenu.classList.add(controlActive);
                currentUl.closest('[data-control-menu-id]')?.classList.add(controlActive);
                const contentTextMobile: HTMLElement | null
                  = controlMenu.querySelector('[data-content-text-mobile]');
                if (contentTextMobile) {
                    contentTextMobile.style.height = 'auto';
                }
                const ul: HTMLUListElement | null = controlMenu.closest('ul')
                if (ul) {
                    ul.style.height = 'auto';
                    const controlMenu: HTMLElement | null = ul.closest('[data-control-menu]');
                    if (controlMenu) {
                        this.recursivelyIterateThroughMenuItems(controlMenu);
                    }
                }
           // }
        }
    }
}
